import { BIOMETRICS_BUTTON_DATA_TYPE } from 'pages/PageEditor/constants';
import { customizeCraftJsComponent } from '../../helpers';
import { EditorButton } from '../EditorButton';

export const EditorPasskeyButton = customizeCraftJsComponent(EditorButton, {
	name: 'Passkey Button',
	props: {
		children: '',
		startIcon: 'passkey',
		shape: 'square',
		variant: 'outline',
		startIconColorText: true,
		'data-type': BIOMETRICS_BUTTON_DATA_TYPE
	}
});
